// To control the order in which shared components are loaded
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ChartistModule } from 'ng-chartist';
import { ClickOutsideModule } from 'ng-click-outside';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { QuillModule } from 'ngx-quill';
import { IDrive, IInbox } from '../../interfaces/graph-types';
import { Highlight } from '../../pipes/highlight.pipe';
import { EscapeHtmlPipe } from '../../pipes/keep-html.pipe';
import { EmailPipe } from '../../pipes/email.pipe';
import { SearchName } from '../../pipes/search-name.pipe';
import { Search } from '../../pipes/search.pipe';
import { SmartConfirmComponent } from './smart-confirm/smart-confirm.component';
import { SmartTagComponent } from './smart-tag/smart-tag.component';
import { SmartButtonComponent } from './smartbutton/smartbutton.component';
import { SmartCheckboxComponent } from './smartcheckbox/smartcheckbox.component';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { LoadingComponent } from './loading/loading.component';
import { SmartInputComponent } from './smartinput/smartinput.component';
import { BillingComponent } from './billing/billing.component';
import { TeamMembersComponent } from './team-members/team-members.component';
import { ProfileComponent } from './profile/profile.component';
import { CandidateInfoComponent } from './candidate-info/candidate-info.component';
import { ApplicationInfoComponent } from './application-info/application-info.component';
import { AvatarComponent } from './avatar/avatar.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { NotificationsInfoComponent } from './notifications-info/notifications-info.component';
import { BulkActionComponent } from './bulk-action/bulk-action.component';
import { AddAttributePopupComponent } from './add-attribute-popup/add-attribute-popup.component';
import { VolumeStatsComponent } from './volume-stats/volume-stats.component';
import { GoogleButtonComponent } from './google-button/google-button.component';
import { MicrosoftButtonComponent } from './microsoft-button/microsoft-button.component';
import { LinkedinButtonComponent } from './linkedin-button/linkedin-button.component';
import { FacebookButtonComponent } from './facebook-button/facebook-button.component';
import { CanDeactivateGuard } from './can-deactivate-guard/can-deactivate-guard';
import { ApplicationPanelComponent } from './application-panel/application-panel.component';

declare global {
  // Smart Button Component callbacks and function prototype

  type onSmartSuccess = () => void;
  type onSmartFailure = (error: string) => void;

  type onSmartButtonCallback = (
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) => void;

  type onSmartCheckboxCallback = (
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) => void;

  type onSmartTagCallback = (
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) => void;

  type onSmartDeleteCallback = (
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) => void;

  type onInboxClickCallback = (
    inbox: IInbox,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) => void;

  type onDriveClickCallback = (
    drive: IDrive,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) => void;

  type onSmartInputCallback = (
    data: any,
    newValue: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) => void;
}

@NgModule({
  declarations: [
    EscapeHtmlPipe,
    EmailPipe,
    Highlight,
    Search,
    SearchName,
    SmartButtonComponent,
    SmartCheckboxComponent,
    SmartConfirmComponent,
    SmartTagComponent,
    SmartInputComponent,
    TextEditorComponent,
    LoadingComponent,
    BillingComponent,
    TeamMembersComponent,
    ProfileComponent,
    CandidateInfoComponent,
    ApplicationInfoComponent,
    ApplicationPanelComponent,
    AvatarComponent,
    NotificationsComponent,
    NotificationsInfoComponent,
    BulkActionComponent,
    AddAttributePopupComponent,
    VolumeStatsComponent,
    GoogleButtonComponent,
    MicrosoftButtonComponent,
    LinkedinButtonComponent,
    FacebookButtonComponent,
  ],
  exports: [
    EscapeHtmlPipe,
    EmailPipe,
    Highlight,
    InfiniteScrollModule,
    Search,
    SearchName,
    SmartButtonComponent,
    SmartCheckboxComponent,
    SmartConfirmComponent,
    SmartTagComponent,
    SmartInputComponent,
    TextEditorComponent,
    LoadingComponent,
    BillingComponent,
    TeamMembersComponent,
    ProfileComponent,
    CandidateInfoComponent,
    ApplicationInfoComponent,
    ApplicationPanelComponent,
    AvatarComponent,
    NotificationsComponent,
    NotificationsInfoComponent,
    BulkActionComponent,
    AddAttributePopupComponent,
    VolumeStatsComponent,
    GoogleButtonComponent,
    MicrosoftButtonComponent,
    LinkedinButtonComponent,
    FacebookButtonComponent,
  ],
  imports: [
    BsDropdownModule.forRoot(),
    ChartistModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PaginationModule.forRoot(),
    QuillModule,
    RouterModule,
    TooltipModule.forRoot(),
    TypeaheadModule.forRoot(),
    ProgressbarModule.forRoot(),
    ClickOutsideModule,
  ],
  providers: [CanDeactivateGuard],
})
export class SharedModule {
  constructor() {
    console.log('>>> SharedModule loaded');
  }
}

console.log('shared.module.ts');
